/* eslint-disable */
import axios from 'axios'
// import { sign } from 'core-js/library/es6/number';
const state = {
    users: []
};
const getters = {
    allUsers(state) {
       return state.users
    }
};
const actions = {
    async SignUpUser({ commit }, payload) {
        
        var formData = new FormData();
        formData.append('ImageFile', payload.profileImg);
        formData.append('firstName', payload.firstname);
        formData.append('lastName', payload.lastname);
        formData.append('email', payload.email);
        formData.append('orgainzation', payload.organization);
        // formData.append('createdDateTime',payload.createdDateTime);
        // formData.append('isActive',payload.isActive);
        formData.append('password', payload.password.password);
        formData.append('roleId', 'b4247d76-08ba-45bf-b569-432279ddfc9c');

        let response = await axios.post("http://localhost:5290/api/Accounts/UserSignUp", formData);
        commit("signUp", response.data)
    },
    async getAllUsers({ commit }) {
        let response = await axios.get("http://localhost:5290/api/Teachers/GetUsersList")
        
        commit("getUsers", response.data)
    },
};
const mutations = {
    getUsers(state, payload) {
        state.users = payload
    },
    signUp(state, user) {
        state.users.unshift(user)
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}